import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// ---------------------------------------------------------------------------
// Timezone helpers — SaarOne operates in IST (Asia/Kolkata).
// DB always stores UTC ISO strings; UI formats to IST for display.
// ---------------------------------------------------------------------------
export const APP_TIMEZONE = "Asia/Kolkata";

const _dtf = (opts) => new Intl.DateTimeFormat("en-IN", { timeZone: APP_TIMEZONE, ...opts });

/** Format an ISO-8601 or Date value as "21 Sep 2026, 1:08 PM" in IST. */
export function fmtIST(value, { withTime = true, withSeconds = false } = {}) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const opts = { day: "2-digit", month: "short", year: "numeric" };
  if (withTime) {
    opts.hour = "2-digit";
    opts.minute = "2-digit";
    if (withSeconds) opts.second = "2-digit";
    opts.hour12 = true;
  }
  return _dtf(opts).format(d);
}

/** Format as "21 Sep 2026" (date only, IST). */
export function fmtISTDate(value) {
  return fmtIST(value, { withTime: false });
}


/** YYYY-MM-DD for the given Date (default now) in IST — never use toISOString() for dates. */
export function isoDateIST(value = new Date()) {
  const d = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat("en-CA", { timeZone: APP_TIMEZONE, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
}

/** "2026-10-14" → "14/10/2026" (display only). */
export function fmtDateIN(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : (iso || "");
}
